export default "__VITE_ASSET__76p4FNnP__";